export enum TrackingEvents {
    BTN_CLICK = 'VWBasic_Button_Click',
    LAYER_LOAD = 'VWBasic_Layer_Load',
    LAYER_CLOSE = 'VWBasic_LayerClose_Click',
    ACCORDION_OPEN = 'VWBasic_AccordionOpen_Click',
    ACCORDION_CLOSE = 'VWBasic_AccordionClose_Click',

    APP_LOAD = 'VWBasic_GenericFeatureApp_Load',
    SEARCH_CLICK = 'VWBasic_FindDealerSearch_Click',
    DEALER_SELECT = 'VWBasic_DealerSelect_Click',
    DEALER_CLICK = 'VWBasic_DealerButton_Click',
}
